import i18n from '@src/common/lib/i18n'
import utils from '@src/common/utils'
export const tableOption = function () {
  return {
    add: '新增',
    edit: '修改',
    view: '查看',
    page: true,
    selection: true,
    index: false,
    indexLabel: '序号',
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewFormSlot: true,
    labelSuffix: '：',
    align: 'left',
    size: 'small',
    maxHeight: '100%',
    labelWidth: '100px',
    labelPosition: 'right',
    menuWidth: 200,
    menuAlign: "center",
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 350,
    dialogWidth: '640px',
    emptyText: '暂无数据',
    menu: false,
    column: [
      {
        label: '编号',
        prop: 'storageCode',
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        align: 'center',
      },
      {
      label: '名称',
      prop: 'storageName',
      addDisplay: false,
      editDisplay: false,
      viewDisplay: true,
      editDisabled: false,
      overHidden: true,
      align: 'center',
    },
    
    {
      label: '库存容量(吨)',
      prop: 'inventoryCapacity',
      addDisplay: false,
      editDisplay: false,
      viewDisplay: true,
      editDisabled: false,
      overHidden: true,
      align: 'center',
    },
    {
      label: '面积(m²)',
      prop: 'area',
      editDisplay: false,
      viewDisplay: true,
      editDisabled: false,
      overHidden: true,
      align: 'center',
    },
    {
      label: '高度(m)',
      prop: 'height',
      addDisplay: false,
      editDisplay: false,
      viewDisplay: true,
      editDisabled: false,
      overHidden: true,
      align: 'center',
    },
    {
      label: '月台数(个)',
      prop: 'platformQuantity',
      addDisplay: false,
      editDisplay: false,
      viewDisplay: true,
      editDisabled: false,
      overHidden: true,
      align: 'center',
    },
    {
      label: '启用状态',
      prop: 'storageStatus',
      slot: true,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: true,
      editDisabled: false,
      overHidden: true,
      align: 'center',
    }
    ]
  }
}